<template lang="pug">
  .light-works-hero.xs-12(v-if="product.id")
    .product-imagery.xs-12.md-7.md-pr-100m
      PdpCarousel(:images="pdpCarouselImages")
        template(#first-image="")
          PdpCarouselRibbon(:product="product")

    .product-info-and-cta.xs-12.md-5
      PdpProductInfo
      PdpMissingAdvisor

      LightWorksSwatchSelector.xs-12.xs-pt-100m.xs-pb-100m

      .desc-wrap.xs-12.text-center.xs-pt-50m.xs-pb-100m
        p.xs-f-small.lg-f-medium.max-at-tweak(itemprop="description") {{ product.description }}

      BTModule.xs-12
      PdpPromotionalMessages.xs-12.xs-pt-100m.xs-pb-100m
      PdpCTAs.info-section.t-line.xs-pt-100m(cta-source="LightWorks").xs-12
      .xs-12
        DeliveryOptions
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import PdpCarousel from '../../PdpCarousel/PdpCarousel';
  import PdpProductInfo from '../../PdpProductInfo/PdpProductInfo';
  import PdpCTAs from '../../PdpCTAs/PdpCTAs';
  import BBCTModule from './BBCTModule';
  import BTModule from './BTModule';
  import LightWorksSwatchSelector from './LightWorksSwatchSelector/LightWorksSwatchSelector';
  import PdpMissingAdvisor from '../../PdpMissingAdvisor/PdpMissingAdvisor';
  import PdpPromotionalMessages from '../../PdpPromotionalMessages';
  import PdpCarouselImageMixin from '../../PdpCarouselImageMixin';
  import PdpCarouselRibbon from '../../PdpCarouselRibbon';
  import DeliveryOptions from '@components/PDP/DeliveryOptions';

  export default {
    name: 'LightWorksHero',

    components: {
      PdpPromotionalMessages,
      PdpMissingAdvisor,
      BBCTModule,
      BTModule,
      LightWorksSwatchSelector,
      PdpCTAs,
      PdpProductInfo,
      PdpCarousel,
      DeliveryOptions,
      PdpCarouselRibbon,
    },

    mixins: [PdpCarouselImageMixin],

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('colorAdvisor', ['lightWorksRecommendations', 'lightWorksQuizCompleted']),
      ...mapGetters('pdp', ['carouselImages']),
      ...mapGetters('customer', ['closestColorbar']),

      pdpCarouselImages() {
        return this.mix_pdpCarouselImages;
      },
    },

    mounted() {
      this.initColorAdvisor();
    },

    methods: {
      ...mapActions('colorAdvisor', ['initColorAdvisor']),
    },
  };
</script>

<style scoped lang="stylus">
  .light-works-hero
    .product-info-and-cta
      .info-section
        position relative

        &.t-line
          &:before
            content ''
            position absolute
            top 0
            left 0
            right 0
            border-top 1px solid ui-color-5

    @media mq-desktop-md-plus
      .product-imagery
        padding-right 1em
        position sticky
        top 3em
</style>
